module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-pad box-size"
  }, [_c('div', {
    staticClass: "col-1-1 box-size"
  }, [_c('isIEOrEdge'), _vm._v(" "), _c('div', {
    staticClass: "dashboard text-dark"
  }, [(_vm.isOnboarding) ? _c('div', {
    staticClass: "box box-overview flex pad-0"
  }, [_c('div', {
    staticClass: "flex-1 box-overview__name"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.welcome')) + " " + _vm._s(_vm.userName) + "!")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.start_by_setting_up')) + " " + _vm._s(_vm.schoolName))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.openSetupWidget
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.dashboard.follow_the_steps')))]), _vm._v(" "), _c('div', {
    staticClass: "flex bg-light-blue flex-1 steps-graph"
  }, [_c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.dashboard.steps_completed')))]), _vm._v(" "), _c('doughnut', {
    attrs: {
      "animate": true,
      "steps": _vm.steps.length,
      "stepNum": _vm.howManyDone
    }
  })], 1)])]) : _c('div', [_c('h1', [_vm._v(_vm._s(_vm.schoolName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-boxes"
  }, _vm._l((_vm.steps), function(step, key) {
    return (key < 4) ? _c('dashboardBox', {
      key: step.dbName,
      attrs: {
        "step": step,
        "isOnboarding": _vm.isOnboarding
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "dashboard-boxes"
  }, _vm._l((_vm.steps), function(step, key) {
    return (key >= 4) ? _c('dashboardBox', {
      key: step.dbName,
      attrs: {
        "step": step,
        "isOnboarding": _vm.isOnboarding
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "slide-up",
    class: {
      'active': _vm.showSlideUp
    }
  }, [_c('div', {
    staticClass: "slide-up__close",
    on: {
      "click": function($event) {
        return _vm.setShowSlideUp(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]), _vm._v(" "), _c('div', {
    staticClass: "slide-up__content box"
  }, [_c('vacationDaySelector', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSlideUp),
      expression: "showSlideUp"
    }],
    attrs: {
      "school-id": _vm.schoolId,
      "emit-event-on-load": false,
      "initial-year": _vm.schoolYear
    },
    on: {
      "schoolDays": _vm.setSchoolDays
    }
  })], 1)])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSlideUp),
      expression: "showSlideUp"
    }],
    staticClass: "modal-mask"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fa0e8f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/School/Dashboard.vue
// module id = 1500
// module chunks = 1